module.exports = __webpack_public_path__ + "static/media/bike2go_2.f94609ac.png";